// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".social-media-links{display:flex;max-width:none;margin:0;padding:0;list-style:none}.social-media-links_item:not(:last-child){margin-right:12px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
